import { Button, ControlGroup, InputGroup, Tag } from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import React from "react";
import { apiCallPost, niceDate } from "../fns/util";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { DateRangeInput } from "@blueprintjs/datetime";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import SingleIDSelectWrapper from "../utils/SingleIDSelectWrapper";
import MultiSelectWrapper from "../utils/MultiSelectWrapper";
import moment from "moment";

class SxSearch extends React.Component {
  today = moment().startOf("day").toDate();
  state = {
    isFTS: true,
    ftsText: "",
    searchingVendors: false,
    vendorSearchResults: [],
    vendorItem: null,
    // createdInStart: this.today,
    // createdInEnd: this.today,
    createdIn: [],
    // approvedInStart: null,
    // approvedInEnd: null,
    approvedIn: [this.today, this.today],
    paidInStart: null,
    paidInEnd: null,
    lifecycle: [
      "DISCHARGED",
      "BOOKED",
      "SX_DONE",
      "LAMA",
      "IN_OT",
      "DEATH",
      "CANCELLED",
      "BILLED",
      "IN_BLOCK_ROOM",
    ],
    anaesthesiaType: [],
    gender: null,
    entityName: null,
    patientName: null,
    patientPhone: null,
    patientPid: null,
    // listOfSxItems: [],
  };

  getData = async () => {
    // if (!this.state.createdIn[0] && this.state.createdIn[1]) {
    //   cogoToast.error("You need to put in both start and end intervals.");
    //   return;
    // }
    // if (!this.state.approvedInStart && this.state.approvedInEnd) {
    //   cogoToast.error("You need to put in both start and end intervals.");
    //   return;
    // }
    if (!this.state.paidInStart && this.state.paidInEnd) {
      cogoToast.error("You need to put in both start and end intervals.");
      return;
    }
    // if (this.state.createdInStart && !this.state.createdInEnd) {
    //   cogoToast.error("You need to put in both start and end intervals.");
    //   return;
    // }
    // if (this.state.approvedInStart && !this.state.approvedInEnd) {
    //   cogoToast.error("You need to put in both start and end intervals.");
    //   return;
    // }
    if (this.state.paidInStart && !this.state.paidInEnd) {
      cogoToast.error("You need to put in both start and end intervals.");
      return;
    }
    let obj = {};
    if (this.state.createdIn && this.state.createdIn.length > 0) {
      obj["sxBookingDtIn"] = [this.state.createdIn[0], this.state.createdIn[1]];
    }
    if (this.state.approvedIn && this.state.approvedIn.length > 0) {
      obj["sxDateIn"] = [this.state.approvedIn[0], this.state.approvedIn[1]];
    }

    if (this.state.surgeonId) {
      obj["surgeonId"] = this.state.surgeonId;
    }
    if (this.state.site) {
      obj["site"] = this.state.site;
    }
    if (this.state.lifecycle.length > 0) {
      obj["lifecycle"] = this.state.lifecycle;
    }

    if (this.state.anaesthesiaType.length > 0) {
      obj["anaesthesiaType"] = this.state.anaesthesiaType;
    }

    if (this.state.gender) {
      obj["gender"] = this.state.gender;
    }

    if (this.state.entityName) {
      obj["entityName"] = this.state.entityName;
    }

    if (this.state.patientName) {
      obj["patientName"] = this.state.patientName;
    }

    if (this.state.patientPhone) {
      obj["patientPhone"] = this.state.patientPhone;
    }

    if (this.state.patientPid) {
      obj["patientPid"] = this.state.patientPid;
    }
    try {
      cogoToast.loading("Searching...");
      this.setState({ isSearching: true });
      let res = await apiCallPost(
        `/booking-sx/${this.props.authStore.prefix}/sxBooking/search`,
        obj
      );
      this.props.onDataLoad(res);
      this.setState({ isSearching: false });
      cogoToast.success("Search completed.");
    } catch (err) {
      this.setState({ isSearching: false });

      cogoToast.error("We ran into an error while searching.");
    }
  };

  // renderSurgeonSearch = () => {
  //   return (
  //     <ControlGroup>
  //       <Tag
  //         minimal
  //         large
  //         interactive
  //         onRemove={() =>
  //           this.setState({
  //             selectedSurgeon: null,
  //             surgeonId: null,
  //             surgeonName: null,
  //           })
  //         }
  //       >
  //         Surgeon
  //       </Tag>
  //       <SingleIDSelectWrapper
  //         showSelectProp={true}
  //         width="200px"
  //         items={this.props.loadedDocs.map((each) => {
  //           return {
  //             ...each,
  //             searchName: `${each.shortcode || ""} | ${each.name}`,
  //           };
  //         })}
  //         selectedItem={this.state.selectedSurgeon}
  //         labelKey="searchName"
  //         onChange={(item) => {
  //           this.setState({
  //             selectedSurgeon: item,
  //             surgeonId: item._id,
  //             surgeonName: item.name,
  //           });
  //         }}
  //       />
  //     </ControlGroup>
  //   );
  // };
  renderVendorDateControls = () => {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          <Tag large intent="primary">
            Surgeries
          </Tag>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              maxWidth: "65vw",
            }}
          >
            <ControlGroup>
              <Tag
                minimal
                large
                interactive
                onRemove={() =>
                  this.setState({
                    selectedSurgeon: null,
                    surgeonId: null,
                    surgeonName: null,
                  })
                }
              >
                Surgeon
              </Tag>
              <SingleIDSelectWrapper
                showSelectProp={true}
                width="200px"
                items={this.props.loadedDocs.map((each) => {
                  return {
                    ...each,
                    searchName: `${each.shortcode || ""} | ${each.name}`,
                  };
                })}
                selectedItem={this.state.selectedSurgeon}
                labelKey="searchName"
                onChange={(item) => {
                  this.setState({
                    selectedSurgeon: item,
                    surgeonId: item._id,
                    surgeonName: item.name,
                  });
                }}
              />
            </ControlGroup>
            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() =>
                  this.setState({
                    site: null,
                  })
                }
              >
                Site
              </Tag>
              <SingleSelectWrapper
                items={this.props.loadedSites}
                onChange={(site) =>
                  this.setState({
                    site: site,
                  })
                }
              />
            </ControlGroup>
            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() =>
                  this.setState({
                    entityName: null,
                  })
                }
              >
                Surgery ID
              </Tag>
              <InputGroup
                // leftIcon="search"
                disabled={this.state.isBusy}
                value={this.state.entityName}
                onChange={(event) =>
                  this.setState({ entityName: event.target.value })
                }
              />
            </ControlGroup>

            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() =>
                  this.setState({
                    patientName: null,
                  })
                }
              >
                Patient Name
              </Tag>
              <InputGroup
                style={{ width: "300px" }}
                // leftIcon="search"
                disabled={this.state.isBusy}
                value={this.state.patientName}
                onChange={(event) =>
                  this.setState({ patientName: event.target.value })
                }
              />
            </ControlGroup>

            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() =>
                  this.setState({
                    patientPhone: null,
                  })
                }
              >
                Patient Number
              </Tag>
              <InputGroup
                // leftIcon="search"
                disabled={this.state.isBusy}
                value={this.state.patientPhone}
                onChange={(event) =>
                  this.setState({ patientPhone: event.target.value })
                }
              />
            </ControlGroup>

            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() =>
                  this.setState({
                    patientPid: null,
                  })
                }
              >
                Patient ID
              </Tag>
              <InputGroup
                // leftIcon="search"
                disabled={this.state.isBusy}
                value={this.state.patientPid}
                onChange={(event) =>
                  this.setState({ patientPid: event.target.value })
                }
              />
            </ControlGroup>

            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() =>
                  this.setState({
                    gender: null,
                  })
                }
              >
                Gender
              </Tag>
              <SingleSelectWrapper
                items={["Male", "Female", "Trans", "Non-Binary", "Other"]}
                selectedItem={this.state.gender}
                onChange={(item) =>
                  this.setState({
                    gender: item,
                  })
                }
              />
            </ControlGroup>
            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ lifecycle: [] });
                }}
              >
                Status
              </Tag>
              <MultiSelectWrapper
                showSelectProp={true}
                items={[
                  "DISCHARGED",
                  "BOOKED",
                  "SX_DONE",
                  "DRAFT",
                  "LAMA",
                  "IN_OT",
                  "DEATH",
                  "CANCELLED",
                  "BILLED",
                  "IN_BLOCK_ROOM",
                ]}
                selectedItems={this.state.lifecycle}
                onChange={(item) => {
                  this.setState({ lifecycle: item });
                }}
              />
            </ControlGroup>

            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ anaesthesia: [] });
                }}
              >
                Anaesthesia
              </Tag>
              <MultiSelectWrapper
                showSelectProp={true}
                items={[
                  "Local Anaesthesia",
                  "Topical Anaesthesia",
                  "General Anaesthesia",
                ]}
                selectedItems={this.state.anaesthesiaType}
                onChange={(item) => {
                  this.setState({ anaesthesiaType: item });
                }}
              />
            </ControlGroup>

            {/* <ControlGroup>
                <Tag
                  large
                  minimal
                  onRemove={() => {
                    this.setState({ listOfSxItems: [] });
                  }}
                >
                  Sugeries
                </Tag>
                <MultiSelectWrapper
                  showSelectProp={true}
                  items={[
                    "IV Accentrix",
                    "IV Razumab",
                    "IV Eylea",
                    "IV Pagenax",
                    "IVTA (IV Triamcinolone acetonide)",
                    "IV Ozurdex",
                    "IV Dexamethasone",
                    "IOAB (Intraocular antibiotic) injection",
                    "Intravitreal antibiotic injection",
                    "IV Moxifloxacin",
                    "IV Ganciclovir",
                    "IV Vancomycin",
                    "IV Ceftazidime",
                    "IV Dexamethasone",
                    "IV Amikacin",
                    "IV Amphotericin B",
                    "IV Cotrimazole",
                    "IV Clindamycin",
                    "IV Foscarnet",
                    "IV Methotrexate",
                    "IV Voriconazole",
                    "IV Avastin",
                    "Intravitreal air injection",
                    "IV C3F8",
                    "SiO (Silicon oil) injection ",
                    "V (Vitrectomy)",
                    "MP (Membrane peeling) ",
                    "EL (Endolaser)",
                    "FGE (Fluid gas exchange)",
                    "FAX (Fluid air exchange)",
                    "C3F8",
                    "SF6",
                    "ILM (Internal limiting membrane) peeling",
                    "ERM (Epiretinal membrane) removal",
                    "Air",
                    "SB (Scleral buckling)",
                    "BB (Belt buckle)",
                    "Internal choroidal drainage",
                    "External choroidal drainage",
                    "IOFB (Intraocular foreign body) removal",
                    "Nucleus removal",
                    "PFCL (Perfluorocarbon liquid)",
                    "Cryotherapy",
                    "ARC (Anterior retinal cryotherapy)",
                    "VL (Vitreous lavage)",
                    "SOR (Silicon oil removal)",
                    "Re-SOI",
                    "Re-Vit",
                    "Lensectomy",
                    "AV (Anterior vitrectomy)",
                    "SiO (Silicon oil) tap",
                    "IV tPA (tissue plasminogen activator)",
                    "PST (Posterior subtenon tricort)",
                    "PPC (Pars plana capsulotomy)",
                    "Phacoemulsification ",
                    "Phaco + PCIOL",
                    "Phaco + ACIOL",
                    "Phaco + SFIOL",
                    "Phaco + Glued IOL",
                    "ECCE + PCIOL",
                    "ECCE + ACIOL",
                    "ECCE + SFIOL",
                    "ECCE + Glued IOL",
                    "SICS",
                    "SICS+ PCIOL",
                    "SICS+ ACIOL",
                    "SICS+ SFIOL",
                    "SICS+ Glued IOL",
                    "ICCE",
                    "ICCE + ACIOL",
                    "ICCE + SFIOL",
                    "ICCE + Glued IOL",
                    "IOL exchange",
                    "PCIOL implantation",
                    "ACIOL implantation",
                    "IOL repositioning",
                    "IOL explantation",
                    "Intracameral antibiotic injection",
                    "IC Moxifloxacin",
                    "IC Ganciclovir",
                    "IC Vancomycin",
                    "IC Ceftazidime",
                    "IC Dexamethasone",
                    "IC Amikacin",
                    "IC Amphotericin B",
                    "IC Cotrimazole",
                    "IC Clindamycin",
                    "IC Foscarnet",
                    "IC Methotrexate",
                    "IC Voriconazole",
                    "IC Avastin",
                    "Intracameral air injection",
                    "IC C3F8",
                    "IC Accentrix",
                    "IC Razumab",
                    "IC Eylea",
                    "IC Pagenax",
                    "IC Dexamethasone",
                    "Cyclocryotherapy",
                    "DLCP (Diode laser cyclophotocoagulation)",
                    "ECP (Endoscopic Cyclophotocoagulation)",
                    "Trab (Trabeculectomy)",
                    "Trabeculotomy",
                    "AGV (Ahmed glaucoma valve)",
                    "AADI (Aurolab aqueous drainage implant)",
                    "Bleb revision",
                    "Bleb needling",
                    "Paracentesis",
                    "Surgical PI (peripheral iridectomy)",
                    "AC wash",
                    "Peritomy",
                    "Conjunctival cyst removal",
                    "Pterygium excision with graft",
                    "Pterygium excision with conjunctival autograft (CLAU)",
                    "Pterygium excision without graft",
                    "Conjunctival suture removal",
                    "OSSN excision",
                    "Conjunctival suture removal",
                    "Conjunctival tear repair",
                    "Excision of conjunctival granuloma",
                    "Conjunctival mass excision",
                    "PK (Penetrating keratoplasty)",
                    "OPK (Optical penetrating keratoplasty)",
                    "TPK (Therapeutic penetrating keratoplasty)",
                    "ICL (Implantable collamer lens)",
                    "Toric ICL (Implantable collamer lens)",
                    "DMEK (Descemet's membrane endothelial keratoplasty)",
                    "DSAEK (Descemet's stripping automated endothelial keratoplasty)",
                    "DSEK (Descemet's stripping endothelial keratoplasty)",
                    "DALK (Deep anterior lamellar keratoplasty)",
                    "C3R (Corneal collagen cross-linking with riboflavin)",
                    "LASIK",
                    "LASEK",
                    "Contoura LASIK",
                    "Contoura LASIK",
                    "iLASIK",
                    "SMILE (Small incision lenticule extraction)",
                    "Corneal suture removal",
                    "PRK (Photorefractive keratectomy)",
                    "PTK (Phototherapeutic keratectomy)",
                    "RK (Radial keratotomy)",
                    "EDTA chelation",
                    "Corneal tattooing",
                    "Corneal foreign body removal",
                    "Corneal debridement",
                    "Diamond burr polishing",
                    "BCL (Bandage contact lens)",
                    "Caterpillar hair removal",
                    "Corneal tear repair",
                    "Medial tarsorrhaphy",
                    "Lateral tarsorrhaphy",
                    "Temporary tarsorrhaphy",
                    "Permanent tarsorrhaphy",
                    "3 snip procedure",
                    "DCR (Dacryocystorhinostomy)",
                    "External DCR (dacryocystorhinostomy)",
                    "Externa DCR (dacryocystorhinostomy) with intubation",
                    "Dressing",
                    "Nasal DCR (dacryocystorhinostomy)",
                    "DCT (Dacryocystectomy)",
                    "Fracture repair",
                    "Globe repair",
                    "Evisceration",
                    "Lateral orbitotomy",
                    "Lid suture removal",
                    "Enucleation",
                    "Lid repair",
                    "Lid reconstruction",
                    "Entropion surgery",
                    "Ectropion surgery",
                    "Lateral tarsal strip",
                    "Temporary punctal plug",
                    "Permanent punctal plug",
                    "Socket reconstruction",
                    "Lacrimal fistulectomy",
                    "Probing and syringing",
                    "Suture removal",
                    "Electroepilation",
                    "Squint surgery - 1 muscle",
                    "Squint surgery - 2 muscles",
                    "Squint surgery - 3 muscles",
                    "Squint surgery - 4 muscles",
                    "Scleral suture removal",
                    "Scleral patch graft",
                    "Scleral tear repair",
                    "Corneoscleral tear repair",
                    "Synechiolysis",
                    "Abscess drainage",
                    "Bubbling",
                    "Cyst removal",
                    "IVMP (Intravenous methyl prednisolone)",
                    "EUA (Examination under anaesthesia)",
                  ]}
                  selectedItems={this.state.listOfSxItems}
                  onChange={(item) => {
                    this.setState({ listOfSxItems: item });
                  }}
                />
              </ControlGroup> */}

            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ createdIn: [] });
                }}
              >
                Booking:
              </Tag>
              <DateRangeInput
                value={this.state.createdIn}
                formatDate={(date) => niceDate(date)}
                parseDate={(str) => new Date(str)}
                minDate={new Date(2021, 0, 1)}
                maxDate={new Date(2030, 0, 1)}
                allowSingleDayRange
                contiguousCalendarMonths={false}
                onChange={(value) => this.setState({ createdIn: value })}
              />
            </ControlGroup>
            <ControlGroup>
              <Tag
                large
                minimal
                onRemove={() => {
                  this.setState({ approvedIn: [] });
                }}
              >
                Sx Date:
              </Tag>
              <DateRangeInput
                value={this.state.approvedIn}
                formatDate={(date) => niceDate(date)}
                parseDate={(str) => new Date(str)}
                minDate={new Date(2021, 0, 1)}
                maxDate={new Date(2030, 0, 1)}
                allowSingleDayRange
                contiguousCalendarMonths={false}
                onChange={(value) => this.setState({ approvedIn: value })}
              />
            </ControlGroup>
            <Button
              loading={this.state.isSearching}
              icon="arrow-right"
              intent="success"
              disabled={this.state.isBusy}
              onClick={() => this.getData()}
            />
          </div>
        </div>
      </div>
      // </Card>
    );
  };
  renderSiteSearch = () => {
    return (
      <ControlGroup>
        <Tag
          minimal
          large
          onRemove={() =>
            this.setState({
              site: null,
            })
          }
        >
          Site
        </Tag>
        <SingleSelectWrapper
          items={this.props.loadedSites}
          onChange={(site) =>
            this.setState({
              site: site,
            })
          }
        />
      </ControlGroup>
    );
  };
  render() {
    return (
      <>
        {/* {this.renderSiteSearch()} */}
        {/* {this.renderSurgeonSearch()} */}
        {this.renderVendorDateControls()}
      </>
    );
  }
}

export default inject("authStore")(observer(SxSearch));
